// Fit at a glance (blocks/sivana-pdp-fit-glance.liquid): once a size is picked, each measurement shows
// that size ("24.5 in, size M"); before that it shows the range the server rendered. Horizon redraws
// product blocks when the variant changes, so the text is re-applied after every redraw.
(() => {
  if (window.sivanaFitGlance) return;
  window.sivanaFitGlance = true;

  const WORDS = {
    xsmall: 'xs', extrasmall: 'xs', small: 's', sm: 's', medium: 'm', med: 'm', large: 'l', lg: 'l',
    xlarge: 'xl', extralarge: 'xl', xxl: '2xl', '2x': '2xl', xxlarge: '2xl', xxxl: '3xl', '3x': '3xl', '2xs': 'xxs',
  };
  const norm = (value) => {
    const key = String(value || '').toLowerCase().replace(/[\s.\-]/g, '');
    return WORDS[key] || key;
  };

  const root = () => document.querySelector('.product-information')?.closest('.shopify-section');

  function chosenSize(section) {
    if (section.classList.contains('sivana-size-pending')) return null;
    const fieldset =
      section.querySelector('fieldset[data-sivana-size-fieldset]') ||
      [...section.querySelectorAll('variant-picker fieldset.variant-option')].find((candidate) =>
        /size/i.test(candidate.querySelector('legend')?.textContent || '')
      );
    return fieldset?.querySelector('input:checked')?.value || null;
  }

  function render() {
    const section = root();
    if (!section) return;
    const size = chosenSize(section);
    section.querySelectorAll('[data-sivana-fit-glance] [data-fit-measure]').forEach((cell) => {
      let text = cell.dataset.range || '';
      if (size) {
        try {
          const pairs = JSON.parse(cell.dataset.values || '[]');
          const match = pairs.find(([name]) => norm(name) === norm(size));
          if (match) text = `${match[1]}, size ${size}`;
        } catch (error) {
          /* keep the range */
        }
      }
      if (cell.textContent !== text) cell.textContent = text;
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      render();
    });
  };

  function start() {
    render();
    document.addEventListener('change', () => setTimeout(render, 30), true);
    document.addEventListener('click', () => setTimeout(render, 30), true);
    document.addEventListener('shopify:product:select', () => setTimeout(render, 60));
    const section = root();
    if (section) {
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
